import { DriverFilters } from "./../model/driver";
import {
  Http,
  Response,
  Headers,
  Request,
  RequestOptions,
} from "@angular/http";
import { throwError as observableThrowError, Observable } from "rxjs";
import { AuthHeaderService } from "../views/authheader.service";
import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { map, catchError } from "rxjs/operators";
import { HttpParams } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class DropoffserviceService {
  dropoffform: string;
  constructor(private http: Http, private _headerService: AuthHeaderService) {
    this.dropoffform = environment.dropoffform;
  }

  SendDropoffform(dropoffdata) {
    // console.log(JSON.stringify(dropoffdata));
    // console.log(this.dropoffform);
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.dropoffform, dropoffdata, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getdroppoffData(loadType= '') {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    if(loadType){
      options.headers.append('loadtype', loadType);
    }
    return this.http.get(this.dropoffform, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }


  getdroppoffDataForLoad(loadId, loadType='') {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    if(loadType){
      options.headers.append('loadtype', loadType);
    }
    return this.http.get(this.dropoffform + "?loadId=" + loadId, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }



  EditDropoff(obj, id) {
    delete obj["_id"];
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.dropoffform + "/" + id, obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  DeleteDropoff(data) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.delete(this.dropoffform + "/" + data._id, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
}
